import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { memo } from 'react';
import { PrimaryList } from '../../design-system';
import { jsx as _jsx } from "react/jsx-runtime";
export var OtherRequirementsPreview = /*#__PURE__*/memo(function (_ref) {
  var otherRequirements = _ref.otherRequirements,
      education = _ref.education,
      certificates = _ref.certificates,
      languages = _ref.languages;
  var hasAnyRequirements = (otherRequirements === null || otherRequirements === void 0 ? void 0 : otherRequirements.length) > 0 || (education === null || education === void 0 ? void 0 : education.length) > 0 || (certificates === null || certificates === void 0 ? void 0 : certificates.length) > 0 || (languages === null || languages === void 0 ? void 0 : languages.length) > 0;
  if (!hasAnyRequirements) return null;
  var itemList = [].concat(_toConsumableArray((otherRequirements === null || otherRequirements === void 0 ? void 0 : otherRequirements.map(function (label) {
    return {
      key: label,
      label: label,
      icon: 'ClipboardDocumentCheckIcon'
    };
  })) || []), _toConsumableArray((education === null || education === void 0 ? void 0 : education.map(function (label) {
    return {
      key: label,
      label: label,
      icon: 'AcademicCapIcon'
    };
  })) || []), _toConsumableArray((certificates === null || certificates === void 0 ? void 0 : certificates.map(function (label) {
    return {
      key: label,
      label: label,
      icon: 'ClipboardDocumentCheckIcon'
    };
  })) || []), _toConsumableArray((languages === null || languages === void 0 ? void 0 : languages.map(function (_ref2) {
    var key = _ref2.key,
        label = _ref2.label,
        level = _ref2.level;
    return {
      key: key,
      label: "".concat(label, " - ").concat(level),
      icon: 'FlagIcon'
    };
  })) || []));
  return /*#__PURE__*/_jsx(PrimaryList, {
    itemList: itemList,
    type: "default"
  });
});
OtherRequirementsPreview.displayName = 'OtherRequirementsPreview';